import { Theme } from "@material-ui/core";
import { VodafoneTheme } from "./Clients/vodafone/Theme";

export const ThemeMapping: Record<string, Theme> = {
  vodafone: VodafoneTheme
};
